import Dashboard from "../Dashboard";
import Layout from "../../../components/Layout";

export default function Anamnese() {
  return Layout(Dashboard, "Anamnese");
}
